const notificationItem = {
  dismissTitle: "Dismiss notification",
  timeAgo: {
    justNow: "just now",
    minutes_one: "{{count}} minute ago",
    minutes_other: "{{count}} minutes ago",
    hours_one: "{{count}} hour ago",
    hours_other: "{{count}} hours ago",
    days_one: "{{count}} day ago",
    days_other: "{{count}} days ago",
    months_one: "{{count}} month ago",
    months_other: "{{count}} months ago",
  },
  revokePI: {
    button: "Revoke PI",
    revoking: "Revoking…",
    success: "PI revoked",
    failure: "Failed to revoke PI",
  },
};

export default notificationItem;
